import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgListView({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 14a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM20 18.5a1 1 0 110 2h-7a1 1 0 110-2h7zM6.5 16a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM20 14.5a1 1 0 110 2h-7a1 1 0 110-2h7zM6.5 3a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM20 7.5a1 1 0 110 2h-7a1 1 0 110-2h7zM6.5 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM20 3.5a1 1 0 110 2h-7a1 1 0 110-2h7z"
        fill={color}
      />
    </svg>
  )
}

export default SvgListView
